/**
 * @props labels: (string[]) - Array of string which contains the labels for pie chart
 * @props colors: (string[]) - Array of hex color codes
 * @props series: (number[]) - Array of number which represents the values of the labels
 * @props chartHeight: (number) - height of the pie chart
 * @props totainlLabel: (string) - label to be shown under the total of the series.
 */

import React from 'react'
import PieChart from '../../../../components/piechart/PieChart'
import styles from "./ActivityPieChart.styles"

const ActivityPieChart = ({ labels = [], colors = [], series = [], chartHeight = 250, totalLabel = "" }) => {

    const total = series.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

    return (

        <div style={styles.chartContainer}>

            <div style={styles.detailsCount}>
                <span style={styles.count}>{total}</span>
                <span style={styles.label}>{totalLabel}</span>
            </div>

            <PieChart
                labels={labels}
                colors={colors}
                series={series}
                height={chartHeight}
            />

        </div>
    )

}

export default ActivityPieChart